/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Cancel_ConfirmInputs */

const en_settings_cancel_confirm = /** @type {(inputs: Settings_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm cancellation`)
};

const id_settings_cancel_confirm = /** @type {(inputs: Settings_Cancel_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi pembatalan`)
};

/**
* | output |
* | --- |
* | "Confirm cancellation" |
*
* @param {Settings_Cancel_ConfirmInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_cancel_confirm = /** @type {((inputs?: Settings_Cancel_ConfirmInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Cancel_ConfirmInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_cancel_confirm(inputs)
	return en_settings_cancel_confirm(inputs)
});